import React from 'react';
import { ThemeProvider } from 'styled-components';
import topData from './TopData';
import { Header } from './components/Header/Header'
import { GlobalStyles } from './components/styles/GlobalStyle'
import { PageSection } from './components/PageSection/PageSection';
import { Footer } from './components/Footer/Footer';
import { AuthContextProvider } from './utils/AuthContext';

const theme = {
  colors: {
    header: '#000',
    body: '#000',
    footer: '#000',
    text: '#eaeaea',
    fontSize: '2px',
  },
  mobile: '600px'
}

function App() {

  return (
    <AuthContextProvider>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <Header />                 
        {topData.map((data) => (
          <PageSection {...data} keys={data.id} />
        ))}
        <Footer />
      </ThemeProvider>
    </AuthContextProvider>
  );
}

export default App;
